import type { Model } from 'flexlayout-react'
import { Actions } from 'flexlayout-react'
import { useCallback } from 'react'

/**
 * Hook that provides tab switching functionality for the editor layout.
 */
export function useTabSwitcher(model: Model | null) {
  const switchToTab = useCallback(
    (tabId: string) => {
      if (!model) return

      try {
        model.doAction(Actions.selectTab(tabId))
      } catch (err) {
        console.error(`Failed to switch to tab ${tabId}:`, err)
        // Tab might not exist, ignore
      }
    },
    [model],
  )

  return { switchToTab }
}
